var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem6A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2409 0 0 1.2408 159.48 77.136)",
    x: -67.15764,
    y: -43,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px"
  }, "10kg"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2409 0 0 1.2408 670.75 77.136)",
    x: -67.15764,
    y: -43,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px"
  }, "20kg"), /*#__PURE__*/React.createElement("path", {
    d: "m661.93 147.61v-30.027h-590.61v30.027h590.61z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.8 148.35v-31.888h-592.6v31.888h592.6m-1.7371-29.779v28.042h-588.75v-28.042h588.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.92 248.11v-77.053h-5.7076v77.053h5.7076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.31 180.61c-7.6929-9.6781-13.897-20.721-18.364-33.005-4.3428 12.284-10.423 23.327-18.364 33.005l18.364-6.7002 18.364 6.7002zm-143.19 67.499v-77.053h-5.7076v77.053h5.7076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.51 180.61c-7.6929-9.6781-13.897-20.721-18.364-33.005-4.3428 12.284-10.423 23.327-18.364 33.005l18.364-6.7002 18.364 6.7002zm-105.34 67.499v-77.053h-5.7076v77.053h5.7076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.8 180.61c-7.817-9.6781-13.897-20.721-18.364-33.005-4.4668 12.284-10.671 23.327-18.364 33.005l18.364-6.7002 18.364 6.7002zm-99.387 67.499v-77.053h-5.7076v77.053h5.7076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.05 180.61c-7.817-9.6781-13.897-20.721-18.364-33.005-4.4668 12.284-10.671 23.327-18.364 33.005l18.364-6.7002 18.364 6.7002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m627.93 43.132c-0.86855-8.9337-5.7076-13.649-14.641-14.517-8.9337 0.74447-13.649 5.5835-14.517 14.517 0.74447 8.9337 5.5835 13.773 14.517 14.641 8.9337-0.86855 13.773-5.8317 14.641-14.641m-5.9558 0c-0.49631 5.2113-3.4742 8.0651-8.6855 8.4374-5.0872-0.49631-7.941-3.3501-8.4374-8.4374 0.49631-5.0872 3.3501-7.941 8.4374-8.4374 5.3354 0.37224 8.1892 3.226 8.6855 8.4374z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613.17 27.499c-9.43 0.86855-14.641 6.0799-15.634 15.634 0.86855 9.6781 6.0799 14.889 15.634 15.882 9.6781-0.86855 14.889-6.2039 15.882-15.882-0.86855-9.5541-6.2039-14.765-15.882-15.634m13.525 15.634c-0.12408 3.7224-1.4889 6.9484-3.8464 9.6781-2.7297 2.4816-5.8317 3.7224-9.6781 3.8464-3.7224-0.12408-6.8243-1.4889-9.43-3.8464-2.6056-2.7297-3.8464-5.8317-3.8464-9.6781s1.2408-6.9484 3.8464-9.43c2.6056-2.6056 5.7076-3.8464 9.43-3.8464s6.9484 1.2408 9.6781 3.8464c2.4816 2.4816 3.7224 5.5835 3.8464 9.43m-23.079 0c0.49631 5.8317 3.7224 9.0578 9.6781 9.6781 6.0799-0.62039 9.3059-3.8464 9.9263-9.6781-0.49631-5.8317-3.8464-9.0578-9.9263-9.6781-5.9558 0.49631-9.1818 3.7224-9.6781 9.6781m4.3428 5.2113c-1.2408-1.4889-1.9853-3.226-2.1093-5.3354 0.12408-2.1093 0.74447-3.8464 2.1093-5.3354 1.3649-1.3649 3.102-2.1093 5.3354-2.1093 4.5909 0.37224 7.0725 2.8538 7.5688 7.3206-0.12408 2.1093-0.86855 3.8464-2.2334 5.3354-1.3649 1.3649-3.102 2.1093-5.3354 2.1093-2.2334 0.12408-3.9705-0.62039-5.3354-1.9853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m655.11 117.46-17.247-74.075h-49.631l-16.999 74.075h83.877z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.61 42.14v0.86855l-17.495 75.564h86.483l-17.619-76.432h-51.369m66.134 74.199h-80.775l16.378-71.842h47.77l16.627 71.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.77 80.356c-0.49631-4.3428-2.8538-6.8243-7.0725-7.3206-4.4668 0.49631-6.9484 2.8538-7.3206 7.3206 0.37224 4.4668 2.8538 6.9484 7.3206 7.3206 4.2187-0.37224 6.5762-2.8538 7.0725-7.3206m-2.9779 0c-0.24816 2.7297-1.613 4.0946-4.0946 4.3428-2.7297-0.24816-4.2187-1.7371-4.3428-4.3428 0.12408-2.4816 1.613-3.8464 4.3428-4.0946 2.4816 0.12408 3.8464 1.4889 4.0946 4.0946z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.57 71.795c-5.3354 0.49631-8.0651 3.3501-8.4374 8.4374 0.37224 5.2113 3.226 8.0651 8.4374 8.4374 5.0872-0.49631 7.817-3.3501 8.3133-8.4374-0.49631-4.9632-3.226-7.817-8.3133-8.4374m-6.2039 8.5614c0.24816-3.7224 2.3575-5.8317 6.2039-6.2039 3.5983 0.37224 5.5835 2.4816 5.9558 6.2039-0.37224 3.8464-2.3575 5.8317-5.9558 6.2039-3.7224-0.37224-5.8317-2.3575-6.2039-6.2039m6.2039-5.3354c-3.3501 0.24816-5.2113 1.9853-5.4595 5.3354 0.24816 3.3501 2.1093 5.2113 5.4595 5.4595 3.3501-0.24816 5.0872-2.1093 5.3354-5.4595-0.24816-3.3501-1.9853-5.0872-5.3354-5.3354m0 8.5614c-1.9853-0.12408-3.102-1.2408-3.226-3.226 0.12408-1.8612 1.2408-2.8538 3.226-2.9779 1.7371 0.12408 2.7297 1.1167 2.9779 2.9779-0.12408 1.9853-1.1167 3.102-2.9779 3.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.54 117.46-8.4374-36.975h-24.816l-8.6855 36.975h41.939z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.97 80.356v-0.86855h-26.677l-8.6855 37.844-0.49631 1.3649h44.792l-0.24816-1.3649-8.6855-36.975m-33.005 35.983 8.1892-34.618h22.955l7.941 34.618h-39.085z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.85 256.92c-2.9779-2.9779-6.4521-4.4668-10.671-4.4668s-7.817 1.4889-10.795 4.4668-4.4668 6.5762-4.4668 10.795 1.4889 7.817 4.4668 10.795 6.5762 4.4668 10.795 4.4668 7.6929-1.4889 10.671-4.4668 4.4668-6.5762 4.4668-10.795-1.4889-7.817-4.4668-10.795z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2384 0 0 1.2408 264.36 273.82)",
    x: 4.84484,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m369.11 256.92c-2.9779-2.9779-6.4521-4.4668-10.671-4.4668s-7.817 1.4889-10.795 4.4668-4.4668 6.5762-4.4668 10.795 1.4889 7.817 4.4668 10.795 6.5762 4.4668 10.795 4.4668 7.6929-1.4889 10.671-4.4668 4.4668-6.5762 4.4668-10.795-1.4889-7.817-4.4668-10.795z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2384 0 0 1.2408 347.62 273.82)",
    x: 4.84484,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m458.94 256.92c-2.9779-2.9779-6.4521-4.4668-10.671-4.4668s-7.817 1.4889-10.795 4.4668-4.4668 6.5762-4.4668 10.795 1.4889 7.817 4.4668 10.795 6.5762 4.4668 10.795 4.4668 7.6929-1.4889 10.671-4.4668 4.4668-6.5762 4.4668-10.795-1.4889-7.817-4.4668-10.795z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2384 0 0 1.2408 437.39 273.82)",
    x: 4.84484,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "3"), /*#__PURE__*/React.createElement("path", {
    d: "m587.86 256.92c-2.9779-2.9779-6.4521-4.4668-10.671-4.4668s-7.817 1.4889-10.795 4.4668-4.4668 6.5762-4.4668 10.795 1.4889 7.817 4.4668 10.795 6.5762 4.4668 10.795 4.4668 7.6929-1.4889 10.671-4.4668 4.4668-6.5762 4.4668-10.795-1.4889-7.817-4.4668-10.795z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2384 0 0 1.2408 566.37 273.82)",
    x: 4.84484,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem6A);
export default __webpack_public_path__ + "static/media/item6a.499d61ba8ecf46a13da8fb8182614c94.svg";
export { ForwardRef as ReactComponent };